import { Box } from '@mui/material';
import * as loadingAnimationData from 'core/assets/lottie/green-loader-animation.json';
import Linked from 'core/components/link/Link';
import BaseTypography from 'core/components/typography/BaseTypography';
import LottieAnimation from 'core/layouts/components/lottie-animation/LottieAnimation';
import { ConditionalLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { APP } from 'core/navigation/Routes';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	currentOAuthTokenSelector,
	currentUserSelector,
} from 'core/store/reducers/appReducer/AppSlice';
import { getGoogleLoginRedirectResult } from 'core/store/reducers/appReducer/appSliceThunk';
import classes from 'platform/desktop/popup-callback/PopupCallback.module.css';

const styles = {
	linkedTextStyles: {
		cursor: 'pointer',
		textDecoration: 'underline',
	},
	loaderContainer: { height: '90px', width: '180px' },
};

function PopupCallback() {
	const dispatch = useDispatch();

	React.useEffect(() => {
		dispatch(getGoogleLoginRedirectResult());
	}, [dispatch]);

	const currentUser = useSelector(currentUserSelector);
	const currentOAuthToken = useSelector(currentOAuthTokenSelector);

	return (
		<Box id="desktop-login-redirect-main-container" className={classes.mainContainer}>
			<ConditionalLayer isShown={currentUser != null && currentOAuthToken != null}>
				<Linked to={`/${APP}`}>
					<BaseTypography
						variant="b1_v2_bold"
						color="colors.light5"
						style={styles.linkedTextStyles}
					>
						Navigate to Webpage
					</BaseTypography>
				</Linked>
				<a href={`rendernet://${currentOAuthToken}`}>
					<BaseTypography
						variant="b1_v2_bold"
						color="colors.light5"
						style={styles.linkedTextStyles}
					>
						Open App if your are not redirected
					</BaseTypography>
				</a>
			</ConditionalLayer>
			<ConditionalLayer isShown={currentUser == null || currentOAuthToken == null}>
				<Box className={classes.loaderContainer}>
					<LottieAnimation animationData={loadingAnimationData} loop />
				</Box>
			</ConditionalLayer>
		</Box>
	);
}

export default PopupCallback;
